/* Original WBTC UI sounds, synthesized live with the Web Audio API.
   No audio files, no external assets. Add-to-cart = a soft two-note pop;
   checkout = a rising four-note confirmation chime.
   Sounds only ever fire from a real click (a user gesture), so browser autoplay
   policies are satisfied and nothing plays on page load.
   Disable globally via the theme setting (window.WBTC_SOUNDS === false) or per
   visitor via localStorage key 'wbtc_sound_off' = '1'. */
(function () {
  if (window.WBTC_SOUNDS === false) return;
  var Ctx = window.AudioContext || window.webkitAudioContext;
  if (!Ctx) return;

  var ac = null;
  function muted() {
    try { return localStorage.getItem('wbtc_sound_off') === '1'; } catch (e) { return false; }
  }
  function ctx() {
    if (!ac) { try { ac = new Ctx(); } catch (e) { return null; } }
    if (ac.state === 'suspended' && ac.resume) ac.resume();
    return ac;
  }
  // One note with a fast attack and exponential decay.
  function tone(c, freq, start, dur, type, peak) {
    var o = c.createOscillator(), g = c.createGain();
    o.type = type || 'sine';
    o.frequency.setValueAtTime(freq, start);
    g.gain.setValueAtTime(0.0001, start);
    g.gain.exponentialRampToValueAtTime(peak || 0.13, start + 0.012);
    g.gain.exponentialRampToValueAtTime(0.0001, start + dur);
    o.connect(g); g.connect(c.destination);
    o.start(start); o.stop(start + dur + 0.03);
  }
  function pop() {
    if (muted()) return;
    var c = ctx(); if (!c) return;
    var t = c.currentTime;
    tone(c, 587.33, t, 0.12, 'triangle', 0.13);        // D5
    tone(c, 880.00, t + 0.055, 0.15, 'triangle', 0.10); // A5
  }
  function chime() {
    if (muted()) return;
    var c = ctx(); if (!c) return;
    var t = c.currentTime;
    var notes = [523.25, 659.25, 783.99, 1046.50];      // C5 E5 G5 C6
    for (var i = 0; i < notes.length; i++) {
      tone(c, notes[i], t + i * 0.072, 0.34, 'sine', 0.12);
    }
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-quick-add], [data-atc]')) pop();
    else if (t.closest('[name="checkout"]')) chime();
  }, true);

  // Exposed so other scripts can trigger the same sounds if needed.
  window.WBTC_playSound = { pop: pop, chime: chime };
})();
